import axios from "../../axiosInstance";
import requests from '../../requests';

import { takeLatest, all, put, call, delay } from "redux-saga/effects";

import { diagramActionTypes } from "./diagram.types";
// import { mainActionTypes } from "../main/main.types";
import {
	// fetchDiagram,
	fetchDiagramSuccess,
	fetchDiagramFailure,
} from "./diagram.actions";
import {
	// fetchDiagramMain,
	fetchDiagramSuccessMain,
	fetchDiagramFailureMain,
} from "../main/main.actions";

import { showNotify } from "../notify/notify.actions";

export function* fetchDiagramRequest({ payload: { diagramId } }) {
	try {
		const url = `${requests.diagrams}/${diagramId}`;
		const { data, error } = yield axios.get(url, {});
		if (error) {
			yield put(fetchDiagramFailure(error));
			yield put(fetchDiagramFailureMain(error));
			yield put(showNotify({ message: 'something_wrong' }));
		} else {
			yield put(fetchDiagramSuccess(data));
			yield put(fetchDiagramSuccessMain(data));
		}
	} catch (e) {
		// yield put(fetchDiagramFailure(e));
		// yield put(fetchDiagramFailureMain(e));
		// yield put(showNotify({ message: 'something_wrong' }));

		yield delay(1000);
		const testData = {
			id: 'default',
			title: 'Delivery App (Uber Eats like)',
			description: 'Project X is a fictional experimental database focused on tracking anomalies and scientific experiments. Ideal for showcasing advanced data modeling concepts like enums, JSON fields, and complex relationships.',
			db_engine: 'postgresql',
			// data: {}
		};
		yield put(fetchDiagramSuccess(testData));
		yield put(fetchDiagramSuccessMain(testData));
	}
}

export function* onFetchDiagram() {
	yield takeLatest(diagramActionTypes.FETCH_DIAGRAM_REQUEST, fetchDiagramRequest);
}

export function* diagramSagas() {
	yield all
		([
			call(onFetchDiagram),
		]);
}